import { render } from "./AskBanner.vue?vue&type=template&id=b2e277d4&scoped=true"
const script = {}

import "./AskBanner.vue?vue&type=style&index=0&id=b2e277d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e277d4"]])

export default __exports__